import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home/Home";
import Services from "./components/Services/Services";
import Contact from "./components/Contact/Contact";
import Navigation from "./components/Navigation/Navigation";
import Chatbot from "./components/Chatbot/Chatbot";
import Footer from "./components/Footer/Footer";
import Products from "./components/Products/Products";


const App = () => {
  return (
    <Router>
      <div className="App">
        {/* Navigation Bar */}
        <Navigation />

        {/* Page Routing */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/Products" element={<Products />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>

        {/* Chatbot on All Pages */}
        <Chatbot />

        {/* Footer */}
        <Footer />
      </div>
    </Router>
  );
};

export default App;
